export default {    
    data(){
        return {
            mix_loading: false,
        }
    },
    computed: {
        
    },
    methods: {
        loading(value = true){
            this.mix_loading = value
            this.$emit("loading", value);
        },
        isLoading(value = null){
            return value !== null ? this.mix_loading === value : this.mix_loading !== false;
        },        
    }  
}
            